module.exports = __webpack_public_path__ + "assets/img/investing.300a97ca.png";